import React from 'react'

import { Typography } from "@mui/material"


export default function pickupDateColumn() {

	return {
		name: 'pickupDate',
		label: 'Pickup Date',
		options: {
			customBodyRowRenderLite: value => <Typography>{value}</Typography>
		}
	}
}